import { render, staticRenderFns } from "./StudentTimetablePrivate.vue?vue&type=template&id=3f6b32bc&scoped=true&lang=pug&"
import script from "./StudentTimetablePrivate.vue?vue&type=script&lang=ts&"
export * from "./StudentTimetablePrivate.vue?vue&type=script&lang=ts&"
import style0 from "./StudentTimetablePrivate.vue?vue&type=style&index=0&id=3f6b32bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6b32bc",
  null
  
)

export default component.exports